import { IApiWithResponse, get } from '@tms/core'

import { TPostSort } from '../types/type'
import type { IListRequest, IPostListRequest, IPostInterestListRequest, IPostListBySearchRequest, IPostRecommendListRequest } from '../types/request'
import type { IPostListReponse } from '../types/response'

export default class PostService {
  /**
   * 게시물 목록 조회
   * @param req
   * @returns
   */
  async getPostList (req: IPostListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)
    const sortType = req.sortType ?? TPostSort.POPULAR

    const response: IApiWithResponse<IPostListReponse> = await get('/board/v1/search/list', {
      currentPage, cntPerPage, categoryNo: req.categoryNo, sortType
    })
    return response.data
  }

  /**
   * 게시물 인기 목록 조회
   * @param req
   * @returns
   */
  async getPostListByPopuplar (req: IListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)
    const sortType = req.sortType ?? TPostSort.POPULAR

    const response: IApiWithResponse<IPostListReponse> = await get('/blog/v1/popular/list', {
      currentPage, cntPerPage, sortType
    })
    return response.data
  }

  /**
   * 게시물 최신 목록 조회
   * @param req
   * @returns
   */
  async getPostListByLatest (req: IListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)
    const sortType = req.sortType ?? TPostSort.POPULAR

    const response: IApiWithResponse<IPostListReponse> = await get('/blog/v1/latest/list', {
      currentPage, cntPerPage, sortType
    })
    return response.data
  }

  /**
   * 게시물 관심 목록 조회
   * @param req
   * @returns
   */
  async getPostListByInterest (req: IPostInterestListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)
    const sortType = req.sortType ?? TPostSort.POPULAR

    const response: IApiWithResponse<IPostListReponse> = await get('/blog/v1/interest/list', {
      currentPage, cntPerPage, sortType, interests: req.interests
    })
    return response.data
  }

  /**
   * 추천 콘텐츠 게시물 목록 조회
   * @param req
   * @returns
   */
  async getPostListByRecommend (req: IPostRecommendListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)

    const response: IApiWithResponse<IPostListReponse> = await get('/recommend/v1/contents/list', {
      currentPage, cntPerPage, recommendSeq: req.recommendSeq
    })
    return response.data
  }

  /**
   * 보도 자료 게시물 목록 조회
   * @param req
   * @returns
   */
  async getPostListByReport (req: IListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)

    const response: IApiWithResponse<IPostListReponse> = await get('/blog/v1/report/list', {
      currentPage, cntPerPage, sortType: req.sortType ?? TPostSort.LATEST
    })
    return response.data
  }

  /**
   * 게시물 목록 조회 - 검색
   * @param req
   * @returns
   */
  async getPostListBySearch (req: IPostListBySearchRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)

    const response: IApiWithResponse<IPostListReponse> = await get('/board/v1/search/list', {
      currentPage, cntPerPage, keyword: req.keyword, sortType: req.sortType ?? TPostSort.POPULAR
    })
    return response.data
  }

  /**
   * 북마크한 게시물 목록 조회
   * @param req
   * @returns
   */
  async getPostListByBookmark (req: IListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)

    const response: IApiWithResponse<IPostListReponse> = await get('/like/v1/blog/list', {
      currentPage, cntPerPage
    })
    return response.data
  }

  /**
   * 팔로잉한 게시물 목록 조회
   * @param req
   * @returns
   */
  async getPostListByFollowing (req: IListRequest): Promise<IPostListReponse> {
    const { currentPage, cntPerPage } = this.defaultPaging(req)

    const response: IApiWithResponse<IPostListReponse> = await get('/follow/v1/blog/list', {
      currentPage, cntPerPage
    })
    return response.data
  }

  /**
 * 페이징 변수 기본값 설정
 * @param req 페이징 변수
 * @returns
 */
  private defaultPaging (req: IListRequest) {
    return {
      currentPage: req.currentPage ?? 1,
      cntPerPage: req.cntPerPage ?? 10
    }
  }
}
